import { render, staticRenderFns } from "./ServicosUtilizadosComponent.vue?vue&type=template&id=6c1a188e&scoped=true&"
import script from "@/pages/relatorios/ServicosUtilizados.js?vue&type=script&lang=js&"
export * from "@/pages/relatorios/ServicosUtilizados.js?vue&type=script&lang=js&"
import style0 from "./ServicosUtilizadosComponent.vue?vue&type=style&index=0&id=6c1a188e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a188e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSelect,VTextField})
